import React, { useCallback, useEffect } from "react";
import ReactDatePicker from "react-datepicker";
import { Icon } from "../../Component";
import { parsePartialTimeInput } from "../../../utils/parsePartialTimeInput";

const TIME_INTERVAL_MINUTES = 5;

function hideSelectedTimeLabel() {
  const timeBoxes = document.querySelectorAll(".react-datepicker__time-box");
  timeBoxes.forEach((timeBox) => {
    const children = Array.from(timeBox.children);
    children.forEach((child) => {
      if (child.tagName !== "UL" && !child.classList.contains("react-datepicker__time-list")) {
        const text = child.textContent || "";
        if (text.includes("Selected time") || text.includes("Selected time:")) {
          child.style.display = "none";
        }
      }
    });
  });
}

function scrollSelectedTimeIntoView() {
  document.querySelectorAll(".react-datepicker-popper").forEach((popper) => {
    const selectedLi = popper.querySelector(".react-datepicker__time-list-item--selected");
    if (selectedLi) {
      selectedLi.scrollIntoView({ block: "nearest", inline: "nearest" });
    }
  });
}

function syncTimePopperDom() {
  hideSelectedTimeLabel();
  scrollSelectedTimeIntoView();
}

const FormTimePicker = ({ selected, onChange, placeholderText, removeIcon, disabled }) => {
  useEffect(() => {
    syncTimePopperDom();
    const timer = setTimeout(syncTimePopperDom, 100);

    const observer = new MutationObserver(hideSelectedTimeLabel);
    const poppers = document.querySelectorAll(".react-datepicker-popper");
    poppers.forEach((popper) => {
      observer.observe(popper, { childList: true, subtree: true });
    });

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [selected]);

  const handleCalendarOpen = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(scrollSelectedTimeIntoView);
    });
    setTimeout(syncTimePopperDom, 100);
  };

  const handleChangeRaw = useCallback(
    (event) => {
      const value = event?.target?.value;
      if (value === undefined || value === null) return;
      const trimmed = String(value).trim();
      if (trimmed === "") {
        onChange(null);
        return;
      }
      const parsed = parsePartialTimeInput(value, selected, TIME_INTERVAL_MINUTES);
      if (parsed) {
        onChange(parsed);
      }
    },
    [onChange, selected]
  );

  return (
    <div className="form-control-wrap">
      <div className="input-group">
        <div className={`input-group-prepend w-100 `}>
          {!removeIcon && <Icon className="input-group-text" name="clock" />}
          <ReactDatePicker
            selected={selected}
            onChange={onChange}
            placeholderText={placeholderText}
            showTimeSelect
            showTimeSelectOnly
            disabled={disabled}
            timeIntervals={TIME_INTERVAL_MINUTES}
            timeCaption="Time"
            timeFormat="HH:mm"
            dateFormat="HH:mm"
            strictParsing={false}
            className={`form-control rounded-0  ${removeIcon ? " rounded-1" : "border-start-0 rounded-end"}`}
            popperPlacement="top-end"
            onCalendarOpen={handleCalendarOpen}
            onChangeRaw={handleChangeRaw}
          />
        </div>
      </div>
    </div>
  );
};

export default FormTimePicker;
